




































































import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import VesselsModule from "@/store/clients/Vessels.module";
import SnackbarModule from "@/store/clients/Snackbar.module";
import machineModelsClient from "Clients/machine-models-client";
import { ExtendedVessel } from "@/types/vessel";

const Vessels = getModule(VesselsModule, store);
const Snackbar = getModule(SnackbarModule, store);

interface MachineModel {
  id: number;
  name: string;
  coreInput: string;
  inputs: string | null;
  output: string | null;
}

interface VesselMachineModelsData {
  vesselId: number;
  machineModels: MachineModel[];
}

@Component({
  components: {},
})
export default class VesselMachineLearningModels extends Vue {
  isLoading = false;
  machineModelsData: VesselMachineModelsData | null = null;
  sortBy = "name";
  sortDesc = false;

  headers = [
    { text: "Model Name", value: "name", sortable: true },
    { text: "Core Input", value: "coreInput", sortable: true },
    { text: "Output", value: "output", sortable: true },
  ];

  get vessel(): ExtendedVessel | null {
    return Vessels.currentVessel;
  }

  get vesselName(): string {
    return this.vessel?.name || "";
  }

  get sortedMachineModels(): MachineModel[] {
    if (!this.machineModelsData) return [];
    return this.machineModelsData.machineModels;
  }

  async fetchVesselMachineModels(): Promise<void> {
    if (!this.vessel?.id) {
      Snackbar.showSnackbar({ text: "Vessel not found" });
      return;
    }

    this.isLoading = true;
    try {
      this.machineModelsData = await machineModelsClient.getVesselMachineModels(this.vessel.id);
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to load machine learning models" });
    } finally {
      this.isLoading = false;
    }
  }

  async created(): Promise<void> {
    await this.fetchVesselMachineModels();
  }
}
